import classNames from 'classnames'
import { ReactNode, useEffect } from 'react'
import { Button, Text } from '../..'
import { defineMessages, useIntl } from 'react-intl'
import Chevron, { UP, DOWN } from '../../buyers/Global/ZipCodeModal/MapListToggle/Chevron'
import styles from './ListViewFilterViewSpacingWrapper.module.scss'
import { setHideMobileBottomNav } from '../../../store/slices/navigation'
import { useDispatch } from 'react-redux'

export const MSG = defineMessages({
  open: {
    id: 'ListViewFilterView.tapOpen',
    defaultMessage: 'Tap to open'
  },
  close: {
    id: 'ListViewFilterView.tapClose',
    defaultMessage: 'Tap to close'
  }
})

export interface ListViewFilterViewSpacingWrapperProps {
  children: ReactNode
  isMobileViewExpanded: boolean
  setIsMobileViewExpanded: (isExpanded: boolean) => void
}
export const ListViewFilterViewSpacingWrapper = ({
  children,
  isMobileViewExpanded,
  setIsMobileViewExpanded
}: ListViewFilterViewSpacingWrapperProps) => {
  const intl = useIntl()
  const dispatch = useDispatch()

  // if mobile panel is opened, we hide the bottom nav. If user leaves the page (component unmounts), need to make sure we show the bottom nav again
  useEffect(() => {
    return () => {
      dispatch(setHideMobileBottomNav(false))
    }
  }, [dispatch])

  return (
    <div
      className={classNames({
        [styles.wrapper]: true,
        [styles.mobileListViewExpanded]: isMobileViewExpanded
      })}
    >
      <Button
        minimal
        aria-hidden='true'
        id='mobileScrollButton'
        data-qa='mapListToggle'
        className={styles.mobileScroll}
        onClick={() => {
          dispatch(setHideMobileBottomNav(!isMobileViewExpanded))
          setIsMobileViewExpanded(!isMobileViewExpanded)
        }}
      >
        <Chevron direction={isMobileViewExpanded ? DOWN : UP} />
        <Text variant='neutralCool' variantCount='700' size='xs'>
          {isMobileViewExpanded ? intl.formatMessage(MSG.close) : intl.formatMessage(MSG.open)}
        </Text>
      </Button>
      <div className={styles.childrenWrapper}>
        {' '}
        <div id='list-top' />
        {children}
      </div>
    </div>
  )
}
